"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileNameFromContentDisposition = void 0;
function getFileNameFromContentDisposition(contentDisposition) {
    if (!contentDisposition)
        return '';
    const match = contentDisposition.match(/filename[^;=\n]*=(?:(['"])(.*?)\1|[^;\n]*)/);
    if (match && match.length === 3) {
        const [_match, _quote, filename] = match;
        return filename;
    }
    return '';
}
exports.getFileNameFromContentDisposition = getFileNameFromContentDisposition;
//# sourceMappingURL=export-file.util.js.map